<template>
  <span>{{get_number}}</span>
</template>

<script>
import ssr, {ssr_window} from "../../helpers/ssr";

const changesInSecond = 50
export default {
  name: "CounterIncrease",
  mixins: [ssr],
  props: {
    src: {
      type: String,
      default: ''
    },
    count_to: {
      type: Number,
      default: 0
    },
    counter_length: {
      type: Number,
      default: 3000
    }
  },
  computed: {
    get_number() {
      return Math.ceil(this.number)
    },
    get_counter_length() {
      if (this.counter_length < 1000) {
        return 1000
      }
      return this.counter_length
    },
    interval_length() {
      return Math.floor(this.get_counter_length / changesInSecond)
    },
    part_to_add_counter() {
      return this.count_to / (this.get_counter_length / this.interval_length)
    }
  },
  data() {
    return {
      number: 0,
      interval_function: null,
    }
  },
  mounted() {
    if (!this.count_to) return
    ssr_window.addEventListener('scroll', this.scrollEvent)
    this.scrollEvent()
  },
  methods: {
    scrollEvent() {
      let {top} = this.$el.getBoundingClientRect()
      if((top - this.window_innerHeight) < 0) {
        this.initCounter()
        this.destroyScrollEvent()
      }
    },
    counterInterval() {
      let new_number = this.number + this.part_to_add_counter
      if (new_number >= this.count_to) {
        this.unsetInterval()
        this.number = this.count_to
        return
      }
      this.number = new_number
    },
    unsetInterval() {
      if (!this.interval_function) return
      clearInterval(this.interval_function)
      this.interval_function = null
    },
    initCounter() {
      this.counterInterval()
      this.interval_function = setInterval(this.counterInterval, this.interval_length)
    },
    destroyScrollEvent() {
      ssr_window.removeEventListener('scroll', this.scrollEvent)
    }
  },
  destroyed() {
    this.destroyScrollEvent()
  },
}
</script>
